import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import { Shell } from './components/Shell'
import { EpisodePage } from './pages/EpisodePage'
import { HomePage } from './pages/HomePage'
import { LandingPage } from './pages/LandingPage'
import { MagicLinkPage } from './pages/MagicLinkPage'
import { NotFoundPage } from './pages/NotFoundPage'
import { ShowPage } from './pages/ShowPage'
import { InvitePage } from './pages/InvitePage'
import { SignInPage } from './pages/SignInPage'
import { PublicEpisodePage } from './pages/public/PublicEpisodePage'
import { PublicLivePage } from './pages/public/PublicLivePage'
import { PublicShowPage } from './pages/public/PublicShowPage'
import { WorkspaceSettingsPage } from './pages/WorkspaceSettingsPage'
import { BillingPage } from './pages/BillingPage'
import { AdminAuditPage } from './pages/admin/AdminAuditPage'
import { AdminBillingPage } from './pages/admin/AdminBillingPage'
import { AdminJobsPage } from './pages/admin/AdminJobsPage'
import { AdminLayout } from './pages/admin/AdminLayout'
import { AdminOverviewPage } from './pages/admin/AdminOverviewPage'
import { AdminProvidersPage } from './pages/admin/AdminProvidersPage'
import { AdminUsagePage } from './pages/admin/AdminUsagePage'
import { AdminUsersPage } from './pages/admin/AdminUsersPage'
import { AdminWorkspacePage } from './pages/admin/AdminWorkspacePage'

/** The signed-in app moved under /studio: old bookmarks keep working. */
function ToStudio() {
  const { pathname, search } = useLocation()
  return <Navigate to={`/studio${pathname}${search}`} replace />
}

/** An old address that moved: same query string, new path. */
function KeepQuery({ to }: { to: string }) {
  const { search } = useLocation()
  return <Navigate to={to + search} replace />
}

export function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<SignInPage />} />
      <Route path="/sign-in" element={<KeepQuery to="/login" />} />
      <Route path="/auth/magic" element={<MagicLinkPage />} />
      <Route path="/invites/:token" element={<InvitePage />} />
      <Route path="/p/:workspaceSlug/:showSlug" element={<PublicShowPage />} />
      <Route path="/p/:workspaceSlug/:showSlug/live" element={<PublicLivePage />} />
      <Route path="/p/:workspaceSlug/:showSlug/:episodeSlug" element={<PublicEpisodePage />} />
      <Route path="/studio" element={<Shell />}>
        <Route index element={<HomePage />} />
        <Route path="shows/:showId/:section?" element={<ShowPage />} />
        <Route path="episodes/:episodeId" element={<EpisodePage />} />
        <Route path="workspace" element={<WorkspaceSettingsPage />} />
        <Route path="billing" element={<BillingPage />} />
        <Route path="admin" element={<AdminLayout />}>
          <Route index element={<AdminOverviewPage />} />
          <Route path="providers" element={<AdminProvidersPage />} />
          <Route path="jobs" element={<AdminJobsPage />} />
          <Route path="audit" element={<AdminAuditPage />} />
          <Route path="billing" element={<AdminBillingPage />} />
          <Route path="usage" element={<AdminUsagePage />} />
          <Route path="users" element={<AdminUsersPage />} />
          <Route path="workspaces/:workspaceId" element={<AdminWorkspacePage />} />
        </Route>
      </Route>
      {['/shows/*', '/episodes/*', '/workspace', '/billing', '/admin/*'].map((path) => (
        <Route key={path} path={path} element={<ToStudio />} />
      ))}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  )
}
